import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs, redirect } from 'react-router';
import { authService } from '~/services/auth/auth-service';
import { authUserQuery } from '~/shared/api/auth-user.queries';
import {
  createRoutes,
  createDashboardRoute,
} from '~/shared/models/create-routes';

export const signInPageLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    await authService.initialized;

    if (!authService.isSignedIn) {
      return null;
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { redirect_url } = params;

    if (redirect_url) {
      return redirect(redirect_url);
    }

    const authUser = await queryClient.ensureQueryData(authUserQuery);

    if (authUser?.shouldShowSystemsList()) {
      return redirect(createRoutes.Systems);
    }

    return redirect(createDashboardRoute());
  };
